export default __webpack_public_path__ + "static/img/in-the-picture-transition.aae4094.png";